import { useOutletContext, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import Answer from 'modules/reviews/components/Review/Answer'
import { useQuestionGroup } from 'modules/reviews/hooks/useQuestionGroup'
import { useQuestionGroupCompetencies } from 'modules/reviews/hooks/useQuestionGroupsCompetencies'

const ReviewQuestionGroupPage = () => {
  const { navigation } = useNavigation()

  const { hasCompetencies } = useOutletContext<{
    hasCompetencies: boolean
  }>()
  const { id: employeeId, review_id: formId, question_group_id: questionGroupId } = useParams()

  const { loading: loadingCompetencies } = useQuestionGroupCompetencies(hasCompetencies)
  const { loading, questionGroup, refresh } = useQuestionGroup(Number(questionGroupId))

  return (
    <Answer
      formId={Number(formId)}
      loadingQuestionGroup={loading}
      loadingCompetencies={loadingCompetencies}
      questionGroup={questionGroup}
      refresh={refresh}
      back={navigation.employees.id.reviews.reviewId.answers.fullPath({
        id: String(employeeId),
        review_id: Number(formId),
      })}
    />
  )
}

export default ReviewQuestionGroupPage
